'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _CheckboxConstants = require('./CheckboxConstants');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UICheckbox',

  propTypes: {
    alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
    'aria-label': _react.PropTypes.string,
    checked: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    id: _react.PropTypes.string,
    indeterminate: _react.PropTypes.bool,
    inline: _react.PropTypes.bool,
    innerPadding: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.PADDING_OPTIONS)).isRequired,
    labelClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.SIZE_OPTIONS)),
    value: _react.PropTypes.any
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alignment: 'start',
      innerPadding: 'default'
    };
  },
  getComputedSize: function getComputedSize() {
    var computedSize = this.props.size || this.context.fieldSize;
    return computedSize;
  },
  checkboxRefCallback: function checkboxRefCallback(ref) {
    this._checkboxEl = ref;
  },
  getLabelClassName: function getLabelClassName(_ref) {
    var alignment = _ref.alignment,
        children = _ref.children,
        className = _ref.className,
        inline = _ref.inline,
        innerPadding = _ref.innerPadding;

    return (0, _reactUtils.classNames)('private-checkbox', _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.PADDING_OPTIONS[innerPadding], _CheckboxConstants.SIZE_OPTIONS[this.getComputedSize()], {
      'private-checkbox--inline': inline,
      'private-checkbox--unlabeled': children == null
    }, className);
  },
  getLabelTextClassName: function getLabelTextClassName(_ref2) {
    var size = _ref2.size;

    return (0, _reactUtils.classNames)('private-checkbox__text', {
      'private-checkbox__text--small': size === 'small'
    });
  },
  getCheckboxClassName: function getCheckboxClassName(_ref3) {
    var indeterminate = _ref3.indeterminate;

    return (0, _reactUtils.classNames)({ indeterminate: indeterminate }, 'sr-only', 'private-checkbox__input');
  },
  handleChange: function handleChange(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onChange = _props.onChange,
        readOnly = _props.readOnly;

    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    (0, _Functions.callIfPossible)(onChange, event);
  },
  renderCheckmark: function renderCheckmark() {
    return _react2.default.createElement(_UICheckmark2.default, { className: 'private-checkbox__icon__inner' });
  },
  renderDash: function renderDash() {
    return _react2.default.createElement(
      'svg',
      {
        role: 'presentation',
        viewBox: '0 0 14 14',
        xmlns: 'http://www.w3.org/2000/svg'
      },
      _react2.default.createElement('path', {
        className: 'private-checkbox__icon__inner',
        d: 'M 2 6 L12 6 L12 9 L2 9 L2 6 z'
      })
    );
  },
  renderLabelText: function renderLabelText(_ref4) {
    var ariaLabel = _ref4.ariaLabel,
        children = _ref4.children,
        size = _ref4.size;

    if (children == null && !ariaLabel) {
      _devLogger2.default.warn({
        message: "UICheckbox: `aria-label` is required if you don't define `children`.",
        key: 'UICheckbox: aria-label required'
      });
    }

    if (children && ariaLabel) {
      _devLogger2.default.warn({
        message: 'UICheckbox: `aria-label` overrides `children` when provided, ' + 'avoid passing both properties.',
        key: 'UICheckbox: aria-label overrides children'
      });
    }

    if (children == null) return null;

    return _react2.default.createElement(
      'span',
      {
        'aria-label': ariaLabel,
        className: this.getLabelTextClassName({ size: size })
      },
      children
    );
  },
  render: function render() {
    var _props2 = this.props,
        alignment = _props2.alignment,
        ariaLabel = _props2['aria-label'],
        checked = _props2.checked,
        children = _props2.children,
        className = _props2.className,
        color = _props2.color,
        defaultChecked = _props2.defaultChecked,
        disabled = _props2.disabled,
        id = _props2.id,
        indeterminate = _props2.indeterminate,
        inline = _props2.inline,
        innerPadding = _props2.innerPadding,
        labelClassName = _props2.labelClassName,
        name = _props2.name,
        __onChange = _props2.onChange,
        readOnly = _props2.readOnly,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['alignment', 'aria-label', 'checked', 'children', 'className', 'color', 'defaultChecked', 'disabled', 'id', 'indeterminate', 'inline', 'innerPadding', 'labelClassName', 'name', 'onChange', 'readOnly', 'value']);

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: this.getLabelClassName({
          alignment: alignment,
          children: children,
          className: className,
          inline: inline,
          innerPadding: innerPadding,
          size: this.getComputedSize()
        })
      }),
      _react2.default.createElement(
        'label',
        {
          className: (0, _reactUtils.classNames)('private-checkbox__label', labelClassName)
        },
        _react2.default.createElement(
          'span',
          { className: 'private-checkbox__inner' },
          _react2.default.createElement('input', {
            checked: checked,
            className: this.getCheckboxClassName({ indeterminate: indeterminate }),
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: id,
            name: name,
            onChange: this.handleChange,
            readOnly: readOnly,
            ref: this.checkboxRefCallback,
            type: 'checkbox',
            value: value
          }),
          _react2.default.createElement(
            'span',
            { className: 'private-checkbox__indicator', style: { color: color } },
            _react2.default.createElement(
              'span',
              { className: 'private-checkbox__icon private-checkbox__check' },
              this.renderCheckmark()
            ),
            _react2.default.createElement(
              'span',
              { className: 'private-checkbox__icon private-checkbox__dash' },
              this.renderDash()
            )
          ),
          this.renderLabelText({
            ariaLabel: ariaLabel,
            children: children,
            size: this.getComputedSize()
          })
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/input/UICheckbox.js
// module id = 158
// module chunks = 0